import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Subtract } from 'utility-types';
// import { Language } from '../_helpers/Languages';

export type AppContextProps = {
    app?: AppDto;
    get: (path: string) => Promise<IPageDto>;
};

const initState: AppContextProps = {
    get: () => void 0 as never
}
export const AppContext = React.createContext<AppContextProps>(initState);

export const Consumer: React.SFC<{
    children: (context: AppContextProps) =>
        React.ReactNode
} & RouteComponentProps<any>> = (props) => {
    return (
        <React.Fragment>
            <AppContext.Consumer>
                {props.children}
            </AppContext.Consumer>
        </React.Fragment>);
};

const ConsumerWithRouter = withRouter(Consumer);

export class AppProvider extends React.Component<{}, AppContextProps> {
    public static cache: { [path: string]: IPageDto } = {}
    public static Consumer = ConsumerWithRouter;
    public static Inject = <P extends { appContext: AppContextProps }>(
        UnwrappedComponent: React.ComponentType<P>
    ) =>
        // tslint:disable-next-line:max-classes-per-file
        class WithApi extends React.Component<
            Subtract<P, { appContext: AppContextProps }>
            > {
            public render() {
                return (
                    <AppProvider.Consumer>
                        {(context) => {
                            return <UnwrappedComponent {...this.props} appContext={context} />;
                        }}
                    </AppProvider.Consumer>
                );
            }
        }

    constructor(props: {}) {
        super(props);

        const appElt = document.getElementById("app") || undefined;
        const env = (process.env.NODE_ENV === 'production') || undefined;
        const json = env && appElt && appElt.innerHTML || undefined;
        const app = json && JSON.parse(json) as AppDto;

        if (app && app.Page) {
            // with router to find the path:
            // AppProvider.cache[] = app.Page;
        }
        this.state = {
            ...initState,
            app: app ? app : undefined,
            get: this._get.bind(this)
        };
    }

    componentDidMount() {
        if (!this.state.app) {
            this._fetchApp()
                .then(app => this.setState(() => ({ app })))
        }
    }

    public render() {
        return (
            <AppContext.Provider value={this.state}>
                {this.props.children}
            </AppContext.Provider>
        );
    }
    private _get(path: string): Promise<IPageDto> {
        const key = `${path || ''}`;
        const cached = AppProvider.cache[key];
        if (cached) {
            return Promise.resolve(cached);
        }
        return this._fetchPage(path);
    }

    private _fetchPage(path: string): Promise<IPageDto> {
        const requestOptions = {
            headers: {
                'Content-Type': 'application/json'
                // 'Accept-Language': Language
            },
            method: 'GET'
        };

        return fetch(`${path}?json`, requestOptions)
            .then(response => {
                return response
                    .json()
                    .then(json => {
                        AppProvider.cache[path] = json;
                        return json;
                    });

            });
    }

    private _fetchApp(): Promise<AppDto> {
        const requestOptions = {
            headers: {
                'Content-Type': 'application/json'
                // 'Accept-Language': Language
            },
            method: 'GET'
        };

        return fetch(`/api/app`, requestOptions)
            .then(response => {
                return response
                    .json()
                    .then(json => {

                        return json;
                    });

            });
    }

}

export default AppProvider;


// WEBPACK FOOTER //
// ./src/_context/App.tsx